import React from "react";
import { InfoText } from "../../../../../../../components";
import { keyToTitle } from "../../../../../../../utils";
import { formatPhoneNumberLength, formatWords2 } from "../../../../../../../utils/stringUtils";

const gender = {
    1: "MALE",
    2: "FEMALE",
    3: "WISH NOT TO SPECIFY",
    4: "OTHER"
}

const PersonalDetails = ({data}) => {
  let personalDetails = [
    {
      "First Name": formatWords2(data?.firstName),
      "Middle Name": formatWords2(data?.middleName),
      "Last Name": formatWords2(data?.lastName),
      Gender: gender[data?.gender],
      "Mobile Primary": data?.mobile?.primary?.number ? `${data?.mobile?.primary?.code || ""} ${formatPhoneNumberLength(data?.mobile?.primary?.code, data?.mobile?.primary?.number)}` : "",
      "Mobile Home": "--",
      "Email Primary": data?.email?.primary?.email,
      "Email Secondary": data?.email?.secondary?.email,
      State: formatWords2(data?.location?.state?.name ?? data?.location?.state) ,
      City: formatWords2(data?.location?.city),
      Zipcode: data?.location?.zipCode,
    },
  ];

  console.log("Personal Details in data: ", data)
  return (
    <div className="flex-1 rounded-lg m-2 shadow-md overflow-auto p-2">
      <h6 className="my-3">Personal Details</h6>
      <div className="grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 my-3 ">
        {Object.entries(personalDetails[0]).map(([key, value]) => {
          return (
            <div className="font-[500]">
              <InfoText
                size="sm"
                key={key}
                title={keyToTitle(key)}
                value={value}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PersonalDetails;
